export const defaults = {
  basePath: undefined,
  tenantCollectionSlug: 'tenants',
  tenantFieldName: 'tenant',
  tenantsArrayFieldName: 'tenants',
  tenantsArrayTenantFieldName: 'tenant',
  tenantSelectorLabel: 'Tenant',
}
